(() => {
  const ROW_SELECTOR = '.productcard__row';
  const STATE = Symbol.for('myart.pdpColumnBalance');

  function directChild(row, className) {
    return Array.from(row.children).find((child) => child.classList?.contains(className)) || null;
  }

  function measure(row) {
    const media = directChild(row, 'productcard__media');
    const info = directChild(row, 'productcard__info');
    if (!media || !info || !row.isConnected) {
      row.removeAttribute('data-myart-short-column');
      return;
    }

    const mediaRect = media.getBoundingClientRect();
    const infoRect = info.getBoundingClientRect();
    const rowRect = row.getBoundingClientRect();
    // A sticky short column moves vertically while the page is scrolled, so
    // its viewport-relative top cannot identify the desktop layout. Stacked
    // columns are wider than their row when their widths are summed.
    const sideBySide = mediaRect.width + infoRect.width <= rowRect.width + 2;

    if (!sideBySide || Math.abs(mediaRect.height - infoRect.height) <= 2) {
      row.removeAttribute('data-myart-short-column');
      return;
    }

    const shorter = mediaRect.height < infoRect.height ? 'media' : 'info';
    if (row.getAttribute('data-myart-short-column') !== shorter) {
      row.setAttribute('data-myart-short-column', shorter);
    }
  }

  function schedule(row) {
    const state = row[STATE];
    if (!state || state.frame) return;
    state.frame = requestAnimationFrame(() => {
      state.frame = 0;
      measure(row);
    });
  }

  function mount(row) {
    if (row[STATE]) return;
    const state = { frame: 0, observer: null };
    row[STATE] = state;
    if (typeof ResizeObserver === 'function') {
      state.observer = new ResizeObserver(() => schedule(row));
      state.observer.observe(row);
      Array.from(row.children).forEach((child) => state.observer.observe(child));
    }
    schedule(row);
  }

  function mountWithin(scope) {
    if (scope.matches?.(ROW_SELECTOR)) mount(scope);
    scope.querySelectorAll?.(ROW_SELECTOR).forEach(mount);
  }

  function unmountWithin(scope) {
    const rows = [];
    if (scope.matches?.(ROW_SELECTOR)) rows.push(scope);
    scope.querySelectorAll?.(ROW_SELECTOR).forEach((row) => rows.push(row));
    rows.forEach((row) => {
      const state = row[STATE];
      if (!state) return;
      state.observer?.disconnect();
      if (state.frame) cancelAnimationFrame(state.frame);
      delete row[STATE];
      row.removeAttribute('data-myart-short-column');
    });
  }

  function start() {
    mountWithin(document);
    document.addEventListener('shopify:section:load', (event) => mountWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => unmountWithin(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
